import { BaseEntity } from '../../shared';

export class Announcementmodel implements BaseEntity {
    constructor(
        public id?: number, // Just to valid interface
        public Title?: string,
        public LegalGrounds?: string,
        public AnnouncementDate?: string,
        public CompanyId?: number,
        public CompanyName?: string,
        public CompanyAddress?: string,
        public CompanyTel?: string,
        public CompanyTaxCode?: string,
        public CompanyRepresentative?: string,
        public CompanyPosition?: string,
        public ClientName?: string,
        public ClientAddress?: string,
        public ClientTel?: string,
        public ClientTaxCode?: string,
        public ClientRepresentative?: string,
        public ClientPosition?: string,
        public InvoiceId?: number,
        public RegisterTemplateId?: number,
        public Denominator?: string,
        public Symbol?: string,
        public InvoiceNo?: string,
        public InvoiceDate?: string,
        public TotalAmount?: number,
        public ServiceName?: string,
        public Reasion?: string,
        public BeforeContain?: string,
        public ChangeContain?: string,
        public AnnouncementType?: number,
        public AnnouncementStatus?: number,
        public CreatedBy?: string,
        public CreatedDate?: string,
        public UpdatedBy?: number,
        public UpdatedDate?: string,
        public ApprovedBy?: number,
        public ApprovedDate?: any,
        public ProcessBy?: number,
        public ProcessDate?: string,
        public UpdateStatus?:number,
        public ActionType?:number,
        
        public CompanySign? :any,
        public CompanySignature? :any,
        public DateCompanySign? :any,
        public ClientSign? :any,
        public ClientSignature? :any,
        public DateClientSign? :any,
        public MinutesNo? :any,
        public SystemSetting?: any,
    ) {
    }
}

export class Item implements BaseEntity {
    constructor(
        public id?: number,
        public companyName?: string,
        public tax?: string,
        public name?: string,
        public address?: string,
        public tel?: number,
        public fax?: number,
        public personContact?: string,
        public email?: string,
        public delegate?: string,
        public bankAccount?: string,
        public bankName?: string,
        public website?: string,
        public description?: string,
        public accountHolder?: string,
        public manager?: string,
        public no?: string,
        public logo?: string,
        public signaturePicture?: string,
        public openFileWhenSign?: boolean,
        public levelAgencies?: number,
        public reportWebsite?: string,
        public reportTel?: string,
        public hasContractNotApporve?: any,
        public signatures? :any,
        public parentName?: string,
        public parentAddress?: string,
        public parentDelegate?: string,
        public parentPosition?: string,
        public parentTel?: number,
        public levelCustomer?: string,
    ) {
    }
}
